<app-capital-container>
  <app-capital-back text="Volver" (click)="volver()"></app-capital-back>

  @if (isLoadingConfig()) {
    <div class="loading-container">
      <p>Cargando configuración del certificado...</p>
    </div>
  } @else if (errorMessage()) {
    <div class="error-container">
      <p>{{ errorMessage() }}</p>
    </div>
  } @else if (certificateConfig(); as config) {
    <div class="certificate-container">
      <h1 class="page-title">{{ config.name }}</h1>
      
      <app-capital-card shadow="normal">
        <div class="card-content">
          <!-- Descripción y validez -->
          <p class="validity-text">
            <svg class="info-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.5"/>
              <path d="M8 7.5V11.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              <circle cx="8" cy="5" r="0.75" fill="currentColor"/>
            </svg>
            {{ config.disclosure }}
          </p>

          <!-- Sección de uso -->
          <div class="usage-section">
            <h2 class="section-title">{{ config.usageTitle }}</h2>
            <p class="section-description">{{ config.description }}</p>
            
            <ul class="usage-list">
              @for (item of config.usageItems; track $index) {
                <li>{{ item }}</li>
              }
            </ul>
          </div>

          <!-- Campos dinámicos del formulario -->
          @if (config.fields && config.fields.length > 0) {
            @for (field of config.fields; track $index) {
              <!-- Saltar campos hidden -->
              @if (field.type !== 'hidden') {
                <div class="form-section">
                  <h3 class="form-label">{{ field.label }}</h3>
                  
                  <!-- Selector de tipo select / account-type -->
                  @if (field.type === 'select' || field.type === 'account-type') {
                    <app-capital-select
                      [placeholder]="field.placeholder || 'Seleccione una opción'"
                      [options]="getDropdownValues(field)"
                      [displayOptions]="getDropdownOptions(field)"
                      [(ngModel)]="formValues[field.fieldName]"
                      (valueChange)="onFieldChange(field.fieldName, $event)">
                    </app-capital-select>
                  }
                  
                  <!-- Selector de período (botones circulares) -->
                  @if (field.type === 'period-selector') {
                    <app-period-selector
                      [options]="getPeriodOptions(field)"
                      [initialValue]="getInitialPeriodValue(field)"
                      (valueChange)="onFieldChange(field.fieldName, $event)">
                    </app-period-selector>
                  }
                  
                  <!-- Dropdown de período -->
                  @if (field.type === 'period-dropdown') {
                    <app-capital-select
                      [placeholder]="field.placeholder || 'Seleccione un período'"
                      [options]="getDropdownValues(field)"
                      [displayOptions]="getDropdownOptions(field)"
                      [(ngModel)]="formValues[field.fieldName]"
                      (valueChange)="onFieldChange(field.fieldName, $event)">
                    </app-capital-select>
                  }
                </div>
              }
            }
          }

          <!-- Email de envío -->
          <div class="email-section">
            <p class="email-text">
              Enviaremos el certificado al correo <strong>{{ userEmail() }}</strong>
            </p>
          </div>

          <!-- Botones de acción -->
          <div class="actions-section">
            <app-primary-button
              [text]="'Enviar al correo'"
              [disabled]="isLoading()"
              (click)="enviarPorCorreo()">
            </app-primary-button>

            <button 
              type="button"
              class="secondary-button"
              [disabled]="isLoading()"
              (click)="imprimir()">
              <img src="/img/print-icon.svg" alt="Imprimir" class="print-icon" />
              <span>Imprimir</span>
            </button>
          </div>
        </div>
      </app-capital-card>
    </div>
  }
</app-capital-container>
